import { GetSearchFacets as getCatalogSearchFacets, GetSearchSuggestions as getCatalogSearchSuggestions } from './service/catalog/access/catalogServiceAccessorREST';

// 510
// GetSearchSuggestions - gets type ahead search suggestions for the given field
export const GetSearchSuggestions = async props => {
  const response = await getCatalogSearchSuggestions({
    facet: props.fieldName,
    indices: props.indices,
    value: props.initialValue,
    limit: props.limit
  });
  return response.items;
};

// 624
// GetSearchFacets - gets the available search facets for all indices in the catalog
export const GetSearchFacets = async () => {
  const response = await getCatalogSearchFacets();
  return {
    facets: response.items
  };
};
//# sourceMappingURL=catalogService.js.map